import { render } from "./GenericPanel.vue?vue&type=template&id=1af8e766&scoped=true&ts=true"
import script from "./GenericPanel.vue?vue&type=script&lang=ts"
export * from "./GenericPanel.vue?vue&type=script&lang=ts"

import "./GenericPanel.vue?vue&type=style&index=0&id=1af8e766&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af8e766"]])

export default __exports__